import { Divider, Typography } from '@tunasong/ui-lib'
import { MusicTheory, ScaleSelect } from '@tunasong/music-ui'
import type { Scale } from '@tunasong/schemas'
import { useState } from 'react'
import styles from './music-theory-page.module.css'

export const MusicTheoryPage = () => {
  const [scale, setScale] = useState<Scale | null>({ root: 'C', type: 'major' })

  return (
    <div className={styles.container}>
      <Typography variant="h6" gutterBottom>
        Select a Scale
      </Typography>
      <ScaleSelect value={scale} onChange={setScale} allowNone={false} />
      <Divider className={styles.divider} />
      {scale && <MusicTheory scale={scale} />}
    </div>
  )
}

export default MusicTheory
